// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "4fbfde7ff98fc02e0bc4" + ".bundle.js";
};